import React from 'react'
import Footer from '../../../Components/Footer'
import TeacherCard from '../../../Components/TeacherCard'
import DrSadiaFayaz_CV from '../../../assets/F_Social_science_Cv/Political Science/Dr Sadia Fayaz CV.pdf'
import DrSUMAIRAGUL_CV from '../../../assets/F_Social_science_Cv/Political Science/Dr SUMAIRA GUL CV .pdf'
import DrZarmina_CV from '../../../assets/F_Social_science_Cv/Political Science/DrZarmina_CV.pdf'
import MegaNavbar from '../../../Components/MegaNavbar'

const Political_Science = () => {
  return (
    <>

     <MegaNavbar/>
      
      <section id="team" className="team section-bg">
        <div className="container">

      <div className="section-title">
        <h2>Political Science</h2>
       
        <p>Faculty of Political Science</p>
      </div>

      <div className="row">

<TeacherCard 
name='Dr. Sadia Fayaz '
profile_name='Assistant Professor, Department of Political Science'
intro='Department of Political Science, Shaheed Benazir Bhutto Women University Peshawar'
email=' : sadiafayaz@sbbwu.edu.pk '
cv={DrSadiaFayaz_CV}
google='https://www.google.com/'
linkedin=''/>
<TeacherCard                                                                                                                                                                                                                                  b
name='Dr. Sumara Gul '
profile_name='Assistant Professor, Department of Political Science'
intro=' Head of  Department Political Science at Shaheed Benazir Bhutto Women University Peshawar.'
email=' : sumaira@sbbwu.edu.pk  '
cv={DrSUMAIRAGUL_CV}
google='https://www.google.com/'
linkedin=''/>
<TeacherCard 
name='Dr. Zarmina Baloch '
profile_name='Assistant Professor, Department of Political Science'
intro='Department of Political Science, Shaheed Benazir Bhutto Women University Peshawar '
email=': dr.zarminabaloch@sbbwu .edu.pk  '
cv={DrZarmina_CV}
google='https://www.google.com/'
linkedin=''/>
      
</div>

</div>
</section>



  <Footer/>
      
    </>
  )
}

export default Political_Science
